<template>
  <div class="list-field options-list mt-2" v-if="options">
    <template v-if="options.length">
      <template v-for="(optionsGroup, groupIdx) in options">
        <div :key="groupIdx" class="mb-2">
          <h5 class="mb-2">{{ optionsGroup.title || optionsGroup.name }}</h5>
          <div
            v-for="(option, idx) in optionsGroup.options"
            :key="idx"
            class="list-field__item"
            :id="option.id"
            :class="{ highlighted: checkHighlighted(option) }"
            @click="$emit('select', option)"
          >
            <span v-html="option.text"></span>
          </div>
        </div>
      </template>
    </template>

    <div class="text-center pa-5" v-else>
      <h4><v-icon color="main">error</v-icon> Not found</h4>
    </div>
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual';

export default {
  name: 'OptionsList',
  props: {
    options: {},
  },
  data() {
    return {
      selectedOption: null,
    };
  },
  watch: {
    options() {
      this.selectedOption = null;
    },
  },
  computed: {
    highlightedOption() {
      if (!this.options.length) return '';
      return this.selectedOption || this.options[0].options[0];
    },
  },
  methods: {
    checkHighlighted(item) {
      if (!this.highlightedOption) return;
      return item.label
        ? item.label === this.highlightedOption.label
        : item.id === this.highlightedOption.id;
    },
    checkKeydown(e) {
      if (e.keyCode == 13) {
        this.$emit('select', this.highlightedOption);
      }
      if (e.keyCode == 40) {
        this.selectItemInList(true);
      }
      if (e.keyCode === 38) {
        this.selectItemInList(false);
      }
    },
    selectItemInList(next) {
      if (!this.highlightedOption) return;

      let currGroupIndex = this.options.findIndex((optGroup) =>
        optGroup.options.some((i) => isEqual(i, this.highlightedOption))
      );
      const groupsLength = this.options.length - 1;

      let currOptionIndex = this.options[currGroupIndex].options.findIndex(
        (i) => i === this.highlightedOption
      );
      const optionsLength = this.options[currGroupIndex].options.length - 1;

      if (next) {
        if (currOptionIndex === optionsLength) {
          currGroupIndex =
            currGroupIndex === groupsLength ? 0 : currGroupIndex + 1;
          currOptionIndex = 0;
        } else {
          currOptionIndex += 1;
        }
      } else {
        if (currOptionIndex === 0) {
          currGroupIndex =
            currGroupIndex === 0 ? groupsLength : currGroupIndex - 1;
          currOptionIndex = this.options[currGroupIndex].options.length - 1;
        } else {
          currOptionIndex -= 1;
        }
      }

      this.selectedOption =
        this.options[currGroupIndex].options[currOptionIndex];
      this.checkElementPosition();
    },
    checkElementPosition() {
      if (!this.selectedOption) return;

      const container = document.querySelector('.options-list');
      const element = document.getElementById(this.selectedOption.id);
      if (!element) return;

      let cTop = container.scrollTop;
      let cBottom = cTop + container.clientHeight;

      let eTop = element.offsetTop;
      let eBottom = eTop + element.clientHeight;

      if (eTop < cTop) {
        container.scrollTop -= cTop - eTop;
      } else if (eBottom > cBottom) {
        container.scrollTop += eBottom - cBottom;
      }
    },
    toggleEventListener(add = false) {
      let method = (add ? 'add' : 'remove') + 'EventListener';
      window[method]('keydown', this.checkKeydown, true);
    },
  },
  mounted() {
    this.toggleEventListener(true);
  },
  beforeDestroy() {
    this.toggleEventListener();
  },
};
</script>
